<template>
  <div
    :class="
      classes(
        n(),
      )
    "
  >
    <div
      :class="
        classes(
          n('divider'),
        )
      "
    >
      <Divider
        :layout="'horizontal'"
      />
    </div>
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, provide } from 'virtual-vue';
import { tabBarProps } from './props';
import { TAB_BAR_INJECT_KEY } from './provide';
import { useVModel } from '../hooks/use-v-model';
import { createNamespace } from '../utils/components';
import Divider from '../divider/divider.vue';
import { emits } from './emits';

const { name, n, classes } = createNamespace('tab-bar');

export default defineComponent({
  name,
  components: {
    Divider,
  },
  props: tabBarProps,
  emits,
  setup(props) {
    const activeIndex = useVModel(props);

    const updateChild = (currentIndex: number | string) => {
      activeIndex.value = currentIndex;
    };

    provide(TAB_BAR_INJECT_KEY, {
      activeIndex,
      updateChild,
    });

    return {
      activeIndex,
      n,
      classes,
      updateChild,
    };
  },
});
</script>
